export const IssueTypes = [
  { label: 'pages.rides.problemType.purchase' },
  { label: 'pages.rides.problemType.device' },
  { label: 'pages.rides.problemType.receipts' },
  { label: 'pages.rides.problemType.ticket' },
  { label: 'pages.rides.problemType.other' },
] as const;
